import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthSessionValid } from '../utils/auth';

interface ProtectedStoreRouteProps {
  children: React.ReactNode;
}

const ProtectedStoreRoute: React.FC<ProtectedStoreRouteProps> = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [authChecking, setAuthChecking] = useState<boolean>(true);

  // Check if user is authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        setAuthChecking(true);
        const valid = await isAuthSessionValid();
        console.log(`Store route auth check: ${location.pathname}`, { valid });
        setIsAuthenticated(valid);
      } catch (error) {
        console.error('Error checking auth:', error);
        setIsAuthenticated(false);
      } finally {
        setAuthChecking(false);
      }
    };
    
    checkAuth();
  }, [location.pathname]);
  
  // Show loading while checking authentication
  if (authChecking || isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return URL
    console.log('Redirecting to login - not authenticated for store route');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedStoreRoute; 